import { progressBarConstants } from '~/components';
import { PATH_NAMES } from '../constants';

const { patterns, labels } = progressBarConstants;

export const PROGRESS_BAR_ITEMS = [
  {
    pattern: patterns.SHOPS_PAGE_PATTERN,
    label: labels.ADDRESS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_ADDRESS },
  },
  {
    pattern: patterns.PARTNERS_PAGE_PATTERN,
    label: labels.PARTNERS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_PARTNER },
  },
  {
    pattern: patterns.SELECT_DATE_PAGE_PATTERN,
    label: labels.SELECT_DATE_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_DATE },
  },
  {
    pattern: patterns.ABOUT_YOU_PAGE_PATTERN,
    label: labels.ABOUT_YOU_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.ABOUT_YOU },
  },
  {
    pattern: patterns.REVIEW_PAGE_PATTERN,
    label: labels.REVIEW_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.REVIEW },
  },
  {
    pattern: patterns.COMPLETE_PAGE_PATTERN,
    label: labels.COMPLETE_PAGE_STEP_LABEL,
    disableSiblings: true,
  },
];

export const V2_PROGRESS_BAR_ITEMS = [
  {
    pattern: patterns.SHOPS_PAGE_PATTERN,
    label: labels.PROPERTY_ADDRESS_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_ADDRESS },
  },
  {
    pattern: patterns.PARTNERS_PAGE_PATTERN,
    label: labels.PARTNERS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_PARTNER },
  },
  {
    pattern: patterns.SELECT_DATE_PAGE_PATTERN,
    label: labels.SELECT_DATE_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.SELECT_DATE },
  },
  {
    pattern: patterns.ABOUT_YOU_PAGE_PATTERN,
    label: labels.ABOUT_YOU_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.ABOUT_YOU },
  },
  {
    pattern: patterns.REVIEW_PAGE_PATTERN,
    label: labels.REVIEW_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.REVIEW },
  },
  {
    pattern: patterns.COMPLETE_PAGE_PATTERN,
    label: labels.COMPLETE_PAGE_STEP_LABEL,
    disableSiblings: true,
  },
];

export const EDIT_PROGRESS_BAR_ITEMS = [
  {
    pattern: patterns.EDIT_ADDRESS_PAGE_PATTERN,
    label: labels.PROPERTY_ADDRESS_STEP_LABEL,
    props: { href: PATH_NAMES.EDIT_ADDRESS },
  },
  {
    pattern: patterns.EDIT_PARTNERS_PAGE_PATTERN,
    label: labels.PARTNERS_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.EDIT_PARTNER },
  },
  {
    pattern: patterns.EDIT_DATE_PAGE_PATTERN,
    label: labels.SELECT_DATE_PAGE_STEP_LABEL,
    props: { href: PATH_NAMES.EDIT_DATE },
  },
];
